import type { AcpSessionEventData } from '@crowdex/agent-contracts';
import { ArrowRight } from 'lucide-react';

const SESSION_EVENT_LABELS = {
  agent: 'Agent',
  model: 'Model',
  effort: 'Reasoning',
  permissions: 'Permissions',
  plan: 'Plan first',
  collaboration: 'Collaboration',
  environment: 'Environment',
  repository: 'Repository',
  branch: 'Branch',
} as const;

export function SessionEventDivider({ data }: { data: AcpSessionEventData }) {
  return (
    <div
      className="my-2 flex w-full items-center gap-3 text-muted-foreground text-xs"
      data-session-event
    >
      <span className="h-px min-w-4 flex-1 bg-border/70" />
      <span className="flex max-w-[80%] flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-lg border border-hairline bg-muted/25 px-3 py-1.5">
        {data.changes.map((change, index) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: An event's changes are positions in it (a field may change twice).
          <span className="flex items-center gap-1" key={`${change.field}-${index}`}>
            {index > 0 && <span className="mr-1 text-border">·</span>}
            <span>{SESSION_EVENT_LABELS[change.field]}</span>
            {change.from !== null && (
              <>
                <span className="font-medium text-foreground/75">{change.from}</span>
                <ArrowRight className="size-3" />
              </>
            )}
            <span className="font-medium text-foreground">{change.to}</span>
          </span>
        ))}
      </span>
      <span className="h-px min-w-4 flex-1 bg-border/70" />
    </div>
  );
}
